import { FluidColumnsRepeaterProps } from '@wix/thunderbolt-components'
import './fluid-columns-repeater'
import style from './style/FluidColumnsRepeater.scss'
import React, { ComponentType, ReactNode, MouseEventHandler, useLayoutEffect, useRef } from 'react'
import _ from 'lodash'
import { IFluidColumnsRepeater } from './types'

const useEffect = process.env.browser ? useLayoutEffect : () => {}

export type FluidColumnsRepeaterCompProps = FluidColumnsRepeaterProps & {
	id: string
	children: (id: string) => ReactNode
}

const FluidColumnsRepeater: ComponentType<FluidColumnsRepeaterCompProps> = ({
	id,
	children,
	items,
	horizontalGap = 0,
	verticalGap = 0,
	onMouseEnter = _.noop,
	onMouseLeave = _.noop,
}) => {
	const wrapperId = `${id}_wrapper`
	const ref = useRef<IFluidColumnsRepeater | null>(null)
	useEffect(() => {
		if (ref.current) {
			ref.current.updateAbsoluteStyles()
		}
	}, [items])

	return (
		<div id={id} onMouseEnter={onMouseEnter as MouseEventHandler} onMouseLeave={onMouseLeave as MouseEventHandler}>
			<div className={style.wrapper} id={wrapperId}>
				<fluid-columns-repeater
					style={{ visibility: 'hidden' }}
					ref={ref}
					horizontal-gap={horizontalGap}
					vertical-gap={verticalGap}
					container-id={wrapperId}
					items={items.length}
					class={style.repeater}
					role="list"
				>
					{items.map((itemId) => children(itemId))}
				</fluid-columns-repeater>
			</div>
		</div>
	)
}

export default FluidColumnsRepeater
